import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { catchError, EMPTY, map, Observable } from 'rxjs';
import { ApiService } from '../services/api.service';
import { ResourcesDeatails } from '../models/resource.model';
import { NavigationService } from '../services/navigation.service';

export const resourcesDetailsResolver: ResolveFn<Observable<ResourcesDeatails>> = (
  route: ActivatedRouteSnapshot
) => {
  const slug: string = route.params['slug'];
  const apiService = inject(ApiService);
  const navigationService = inject(NavigationService)

  return apiService.getResourcesDetails(slug).pipe(
    map((resp) => {
      if (resp.header.success && resp.data) {
        return resp.data;
      }

      throw new Error(resp.header.msg);
    }),
    catchError((error) => {
      navigationService.handleResolverError(error)
      return EMPTY;
    })
  );
};
